import { render, staticRenderFns } from "./rules-user.vue?vue&type=template&id=289d2269&scoped=true"
import script from "./rules-user.vue?vue&type=script&lang=js"
export * from "./rules-user.vue?vue&type=script&lang=js"
import style0 from "./rules-user.vue?vue&type=style&index=0&id=289d2269&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289d2269",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('289d2269')) {
      api.createRecord('289d2269', component.options)
    } else {
      api.reload('289d2269', component.options)
    }
    module.hot.accept("./rules-user.vue?vue&type=template&id=289d2269&scoped=true", function () {
      api.rerender('289d2269', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P4_Page/BaseRules/rules-user.vue"
export default component.exports